export const DB_BACKUP_REQUEST  = 'DB_BACKUP_REQUEST';
export const DB_BACKUP_HISTORY_REQUEST  = 'DB_BACKUP_HISTORY_REQUEST';
export const DB_BACKUP_REQUEST_SUCCESS  = 'DB_BACKUP_REQUEST_SUCCESS';
export const DB_BACKUP_REQUEST_FAILURE  = 'DB_BACKUP_REQUEST_FAILURE';